//TODO change file name to base.ts to enable typescript
export default {
    100: 'Der Benutzer kann nicht gefunden werden, bitte überprüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.',
    101: 'Der Benutzer kann nicht gefunden werden, bitte überprüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.',
    401: 'Ein Fehler ist aufgetreten, bitte versuchen Sie erneut. Code: 401',
    604: 'Die Kodierung des hochgeladenen Response wird nicht unterstützt.',
    602: 'Dieses Dateiformat wird nicht unterstützt.',
    600: 'Sie müssen entweder eine Datei hochladen oder den Inhalt im Textfeld eingeben',
    1000: 'Bitte füllen Sie alle Felder aus',
    1001: 'Passwörter stimmen nicht überein',
    1002: 'Unbekannte Rolle',
    1101: 'Bitte wählen Sie einen Kunden aus',
    1100: 'Unbekannter Kunde',
    1003: 'Bitte wählen Sie mindestens ein Produkt aus',
    1004: 'Sie haben keine Berechtigung, diesen Vorgang durchzuführen',
    301: 'Ein Fehler ist aufgetreten, bitte versuchen Sie erneut. Code: 301',
    403: 'Daten konnten für das gewählte Datum nicht gefunden werden',
    405: 'Datum-Format entspricht nicht dem Format dd-mm-yyyy hh:mm:ss',
    400: 'Ein Fehler ist aufgetreten, bitte versuchen Sie erneut. Code: 400',
    603: 'Der ausgewählte Upload-Endpunkt kann nicht gefunden werden.',
    1005: 'Dieser Benutzername wurde bereits von anderem Nutzer verwendet.'

}